class VideoEvent {

	// state changes

	get LOAD() { return 'load'; }
	get LOAD_ERROR() { return 'load-error'; }

	get LOADED_META_DATA() { return 'loaded-meta-data'; }

	get PAUSE() { return 'pause'; }
	get PLAY() { return 'play'; }
	get PLAYING() { return 'playing'; }
	get SEEK() { return 'seek'; }

	get RELOAD() { return 'reload'; }
	get UNLOAD() { return 'unload'; }

	// commands

	get TRIGGER_RELOAD() { return 'triggerReload'; }

}

export default new VideoEvent();
